// src/pages/LandingPage.jsx
import { useNavigate } from 'react-router-dom';
import styles from '../styles/LandingPage.module.css';
import T from '../components/T';
import LanguageSwitcher from '../components/LanguageSwitcher';

const CustomerIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

const StaffIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const ArrowIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

export default function LandingPage() {
  const navigate = useNavigate();

  return (
    <div className={styles.page}>
      {/* Background orbs */}
      <div className={`${styles.orb} ${styles.orb1}`} />
      <div className={`${styles.orb} ${styles.orb2}`} />
      <div className={`${styles.orb} ${styles.orb3}`} />

      <div className={styles.container}>
        {/* Logo & brand & language switcher */}
        <div className={styles.brand} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div className={styles.logoWrap}>
            <img src="/logo_autochek.webp" alt="Autochek" className={styles.brandLogo} />
          </div>
          <LanguageSwitcher variant="light" />
        </div>

        {/* Heading */}
        <div className={styles.hero}>
          <div className={styles.badge}>
            <span className={styles.badgeDot} />
            <span><T>Support Portal</T></span>
          </div>
          <h1 className={styles.heading}>
            <T>How can we</T> <span className={styles.accent}><T>help you today?</T></span>
          </h1>
          <p className={styles.sub}>
            <T>Choose the option that best describes you to get started.</T>
          </p>
        </div>

        {/* Choice cards */}
        <div className={styles.cards}>
          {/* Customer card */}
          <button
            id="btn-customer"
            className={`${styles.card} ${styles.customerCard}`}
            onClick={() => navigate('/customer')}
          >
            <div className={styles.cardGlow} />
            <div className={styles.cardIcon}>
              <CustomerIcon />
            </div>
            <div className={styles.cardBody}>
              <h2 className={styles.cardTitle}><T>Customer</T></h2>
              <p className={styles.cardDesc}>
                <T>Submit a support request, report an issue, or get help with your vehicle or loan.</T>
              </p>
            </div>
            <div className={styles.cardArrow}>
              <ArrowIcon />
            </div>
          </button>

          {/* Staff card */}
          <button
            id="btn-staff"
            className={`${styles.card} ${styles.staffCard}`}
            onClick={() => navigate('/staff')}
          >
            <div className={styles.cardGlow} />
            <div className={styles.cardIcon}>
              <StaffIcon />
            </div>
            <div className={styles.cardBody}>
              <h2 className={styles.cardTitle}><T>Staff</T></h2>
              <p className={styles.cardDesc}>
                <T>Raise an internal request, report a production bug, or log a system incident.</T>
              </p>
            </div>
            <div className={styles.cardArrow}>
              <ArrowIcon />
            </div>
          </button>
        </div>

        {/* Footer */}
        <p className={styles.footer}>
          © {new Date().getFullYear()} Autochek Africa. <T>All rights reserved</T>.
        </p>
      </div>
    </div>
  );
}
